import React from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import { ICoolingSiteItem } from '../../../modules/API/Defaults/models/coolingSites'
import SnowflakeIcon from '../../icons/IconLib/SnowflakeIcon'

interface Props {
  coolingSites: ICoolingSiteItem[]
  value: ICoolingSiteItem | null
  onSelect: (site: ICoolingSiteItem | null) => void
  placeholder?: string
  disabled?: boolean
  readOnly?: boolean
  className?: string
}

const CoolingSiteSelector: React.FC<Props> = ({
  coolingSites,
  value,
  onSelect,
  placeholder = 'בחר חדר קירור',
  disabled,
  readOnly,
  className,
}) => (
  <SearchableSelect<ICoolingSiteItem>
    items={coolingSites}
    value={value}
    onSelect={onSelect}
    getKey={(s) => s.SiteID}
    getLabel={(s) => (s.SiteDesc ?? '').trim()}
    getSearchText={(s) => `${s.SiteDesc ?? ''} ${s.SiteID ?? ''}`}
    placeholder={placeholder}
    disabled={disabled}
    readOnly={readOnly}
    leadingIcon={<SnowflakeIcon />}
    className={className}
    emptyLabel='אין חדרי קירור מתאימים'
  />
)

export default CoolingSiteSelector
